import React from 'react';
import { Table } from 'antd';

import "./styles.scss"

const CustomTable = ({ totalRows, tableData, page, setPage, limit, setLimit, isLoading, rowSelection }) => {
       
    const handleTableChange = (pagination) => {
        setPage(pagination.current);
        setLimit(pagination.pageSize);
    };

    return (
        <div className='custom-table'>
            <Table
                loading={isLoading}
                columns={tableData.columns}
                dataSource={tableData.dataSource}
                pagination={{
                    current: page,
                    pageSize: limit,
                    total: totalRows || tableData.total,
                    showTotal:(total)=> `Total : ${total} records`,
                    pageSizeOptions: ["10", "20", "50", "100","200","500"], 
                    showSizeChanger: true,
                }}
                onChange={handleTableChange}
                rowSelection={rowSelection}
            />
        </div>
    );
};

export default CustomTable;
